
// SEMESTERS
export const GET_SEMESTERS = "/semesters";
export const ADD_NEW_SEMESTER = "/semesters";
export const UPDATE_SEMESTER = "/semesters";
export const DELETE_SEMESTER = "/semesters";


